import { FC } from 'react'
import cx from 'classnames'

import { LinkProps } from '../Link'

import * as SC from './styled'

export type BreadcrumbProps = {
  className?: string
  links?: LinkProps[]
  texts?: {
    label?: string
  }
}

const Breadcrumb: FC<BreadcrumbProps> = ({ className, links, texts }) => {
  return links && links.length > 0 ? (
    <SC.Container
      className={cx('Breadcrumb', className)}
      aria-label={texts?.label}
    >
      <SC.List>
        {links.map((link, index) => (
          <li key={`Breadcrumb-${index}`}>
            <SC._Link {...link} />
            {index < links.length - 1 && <SC.Separator> &gt; </SC.Separator>}
          </li>
        ))}
      </SC.List>
    </SC.Container>
  ) : null
}

export default Breadcrumb
